const style = {
  light: {
    primary: '#6A76AB',
    secondary: '#C4AFB1',
    accent: '#BF7B7E',
    // error: '#b71c1c',
    // warning: '',
    // info: '',
    // success: '',
    text: '#2d2d2d',
    filArianeBg: '#EFE0E2',
    selectPink: '#F7F0F1',
    white: '#FCFCFE',
    actifLink: '#FF4E6A',
    headerDrawer: '#5d6490',
    textLight: '#cecece',
    label: '#777777',
    green: '#45b197',
    updatedGrey: '#C5AFB2',
    inactiveItem: '#ff7474',
    interniste: '#ffc080',
    cardiologue: '#32ffbe',
    gynecologue: '#ffcccc',
    antecedent: '#00ffff',
    documentVu: '#9ae29a',
    redExtraciem: '#CD0522',
    headersCards: '#AD1457',
    headerCardIndigo: '5C6BC0',
  },
  dark: {
    primary: '#6A76AB',
    secondary: '#C4AFB1',
    accent: '#BF7B7E',
    // error: '#b71c1c',
    // warning: '',
    // info: '',
    // success: '',
    text: '#2d2d2d',
    filArianeBg: '#EFE0E2',
    selectPink: '#F7F0F1',
    white: '#FCFCFE',
    actifLink: '#FF4E6A',
    headerDrawer: '#5d6490',
    textLight: '#cecece',
    label: '#777777',
    green: '#45b197',
    updatedGrey: '#C5AFB2',
    inactiveItem: '#ff7474',
    redExtraciem: '#CD0522',
  },
}

export default style
